export default __webpack_public_path__ + "static/media/img12.9a835079.PNG";